module.exports = __webpack_public_path__ + "static/img/help_06_01.83cc555.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fdback/help_06_01.jpg
// module id = 697
// module chunks = 140